import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { WorkflowTeamSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'

import { EntitySelectorComponent } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

const TeamSelector: EntitySelectorComponent = ({ value, onChange, error }) => {
  const { data, loading: teamsLoading } = useQuery(WorkflowTeamSelectorDocument)

  const availableTeams = data?.teams?.teamsConnection?.nodes || []
  const selectedTeam = value ? availableTeams.find((team) => team.id === value) : undefined
  const selectedEntities = selectedTeam
    ? [{ id: selectedTeam.id, name: selectedTeam.name, avatar: buildUrl(selectedTeam.avatar) }]
    : []

  return (
    <EntitySelect
      label="Select team"
      hideLabel
      loading={teamsLoading}
      entities={availableTeams.map(({ id, avatar, name }) => ({
        avatar: buildUrl(avatar),
        expanded: false,
        id,
        name,
      }))}
      notFoundSubtitle="No teams found"
      notFoundTitle="Teams not found"
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(selection: EntitySelectEntity | null) => {
        onChange(selection?.id ?? null)
      }}
      searchPlaceholder="Search teams..."
      selectedEntities={selectedEntities}
      selectedLabel="Selected"
      singleSelector
      size="md"
      placeholder="Select team..."
      selectedItemsCopy="Teams selected"
      groups={[]}
      selectedGroup="all"
      clearLabel="Clear"
      selectAllLabel="Select all"
      error={error}
    />
  )
}

export default TeamSelector
